<template>
    <div class="col-md-10 mx-auto">
        <div>
            <page-title :title="$t('sideMenu.releaseInfo')" :showTitle="false"></page-title>
        </div>

        <div class="mb-5">
            <ReleaseInfo></ReleaseInfo>
        </div>
    </div>
</template>

<script>
    import ReleaseInfo from '../../components/administration/ReleaseInfo'
    import PageTitle from '../../components/common/PageTitle';

    export default {
        components: {
            ReleaseInfo,
            PageTitle
        },
        data() {
            return {
                
            };
        },
        methods: {
 
        },
        computed: {
           
        },
        mounted() {
            
        }
    };
</script>

<style>
</style>
